import { ModuleSelectionsTranslation } from 'locales/de/pages/AWPM-FWPM/moduleSelections';

const en: ModuleSelectionsTranslation = {
  title: { awpm: 'AWPM selection overview', fwpm: 'FWPM selection overview' },
  createSelection: 'New selection',
  activeTab: 'Active',
  inactiveTab: 'Inactive',
  archiveTab: 'Archived',
  draftTab: 'Draft',
  failedLoading: 'Failed to load module selections.',
  noSelections: 'No module selections were found.',
  condition: 'Condition',
  filter: {
    search: 'Search...',
    startDate: 'Start date',
    endDate: 'End date',
    courseOfStudy: 'Courses of study',
    courseOfStudyQuickInfo:
      'You can select several courses here. All selections relating to at least one of the selected courses will then be displayed.',
    mySelections: 'My selections'
  },
  sort: {
    nameAsc: 'Name ascending',
    nameDesc: 'Name descending'
  },
  dischargeStudentsUntil: 'Dischargable by students',
  createdBy: 'Created by',
  participants: 'Other participants',
  startEmailNotification: 'Start E-mail notifications',
  useAsTemplate: 'Use as Template',
  viewOccupancy: 'View Occupancy',
  global: 'All courses',
  createModalTitle: { awpm: 'New AWPM module selection', fwpm: 'New FWPM module selection' },
  editModalTitle: 'Edit module selection',
  createModalTemplateTitle: 'Reuse selection as template',
  create: {
    saveDraft: 'Save Draft',
    steps: {
      generalInfo: 'General info',
      periodsAndExtraInfo: 'Periods & Extra'
    },
    generalInfo: {
      title: 'Title',
      generalNotes: 'General Notes',
      electionTip: 'Selection Tips',
      attachments: 'Attachments',
      viewer: 'Observing roles',
      tooltips: {
        viewingRoles:
          'Persons with one of the selected roles may view the election, but with read access.'
      },
      organizingPersons: 'Additional observers'
    },
    periodsAndExtraInfo: {
      electionTimeframe: 'Selection timeframe',
      startDate: 'Start date',
      endDate: 'End date',
      extraTimeframes: 'Other Timeframes',
      dischargeByStudentsUntil: 'Dischargable by students until',
      contentVisibleFrom: 'Content visible from',
      maxSelectedModules: 'Max. selectable modules',
      lengthOfTheWishlist: 'Length of the wish list',
      activeInAllCommunities: 'Active in all Communities'
    },
    alerts: {
      saveFailed: 'Creation of module selection failed.',
      editFailed: 'Edit of module selection failed.',
      saveSuccessful: 'Module selection sucessfully created.',
      editSuccessful: 'Module selection sucessfully edited.',
      createFromTemplateSuccessful: 'Module selection succeffully created from template.',
      createFromTemplateFailed: 'Module selection could not be created from template.'
    }
  },
  allocation: {
    listHeaders: {
      minParticipants: 'Min PAR',
      maxParticipants: 'Max PAR',
      countParticipants: 'Count PAR',
      countWaitinglist: 'Count WL'
    }
  },
  states: {
    dischargable: 'Move-up procedure',
    active: 'Active',
    inactive: 'Inactive',
    completed: 'Completed',
    draft: 'Draft',
    archived: 'Archived',
    started: 'Started'
  }
};

export default en;
